/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import type { ImageType } from 'bundles/cds-labs/components/Modules/components/Image';
import Image from 'bundles/cds-labs/components/Modules/components/Image';
import { getColorFromColorName, getFgColorFromBgColorName } from 'bundles/cds-labs/components/Modules/utils/colors';

type Props = {
  text?: string | null;
  background?: string | null;
  image?: ImageType | null;
};

const styles = {
  eyebrow: css`
    margin-bottom: var(--cds-spacing-150);
  `,

  eyebrowBackground: css`
    padding: 2px var(--cds-spacing-150);

    /* ensure round corners regardless of height */
    border-radius: 1000px;
  `,
};

function Eyebrow({ text, background, image }: Props) {
  const pillStyles: Array<SerializedStyles> = [];
  if (background) {
    const bgColor = getColorFromColorName(background);
    if (bgColor) {
      const color = getFgColorFromBgColorName(background);
      pillStyles.push(
        css`
          background-color: ${bgColor};
          color: ${color};
        `
      );
      pillStyles.push(styles.eyebrowBackground);
    }
  }

  return (
    <div>
      {image && <Image {...image} height={Math.min(image.height ?? 34, 34)} css={styles.eyebrow} />}
      {!image && text && (
        <div css={styles.eyebrow}>
          <span css={pillStyles}>
            <Typography2 variant="subtitleMedium" component="span" color="inherit">
              {text}
            </Typography2>
          </span>
        </div>
      )}
    </div>
  );
}

export default Eyebrow;
